import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoUserLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_2539_121414)",
		children: [
			/* @__PURE__ */ _jsx("circle", {
				cx: 8,
				cy: 8,
				r: 7.5,
				stroke: "currentColor",
				strokeOpacity: .08,
				strokeDasharray: "4 4"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M5.35546 9.60986C6.07044 9.37015 7.01761 9.29785 7.99246 9.29785C8.9732 9.29785 9.92068 9.37296 10.6347 9.6158C10.9937 9.73789 11.321 9.91129 11.5618 10.1637C11.8113 10.4252 11.9522 10.7558 11.9522 11.1467C11.9522 11.5383 11.8101 11.8688 11.5591 12.1293C11.3171 12.3805 10.9886 12.5523 10.6293 12.6728C9.91441 12.9126 8.96735 12.985 7.99246 12.985C7.01176 12.985 6.06417 12.91 5.35004 12.6672C4.991 12.5452 4.6636 12.3718 4.4227 12.1193C4.17316 11.8578 4.03223 11.5271 4.03223 11.1362C4.03223 10.7445 4.17443 10.4139 4.42541 10.1534C4.6675 9.90208 4.99607 9.73036 5.35546 9.60986ZM4.96555 10.6737C4.84646 10.7973 4.78223 10.9424 4.78223 11.1362C4.78223 11.3307 4.84642 11.477 4.96531 11.6016C5.09285 11.7352 5.2972 11.8571 5.59144 11.9572C6.18385 12.1585 7.02888 12.235 7.99246 12.235C8.95139 12.235 9.79671 12.161 10.3908 11.9617C10.6859 11.8627 10.891 11.7418 11.019 11.6089C11.138 11.4853 11.2022 11.3403 11.2022 11.1467C11.2022 10.9522 11.1381 10.806 11.0192 10.6814C10.8917 10.5478 10.6874 10.4259 10.3932 10.3259C9.80092 10.1244 8.95601 10.0479 7.99246 10.0479C7.0335 10.0479 6.18806 10.1217 5.59387 10.321C5.29868 10.4199 5.09353 10.5409 4.96555 10.6737Z",
				fill: "currentColor",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M5.31935 5.70421C5.31969 4.22825 6.51662 3.03223 7.99246 3.03223C9.46861 3.03223 10.6651 4.22869 10.6651 5.70485C10.6651 7.1809 9.46871 8.37794 7.99246 8.37794H7.97627L7.975 8.37794C6.50372 8.37295 5.31472 7.17569 5.31935 5.70421ZM5.31935 5.70421C5.31935 5.704 5.31935 5.70379 5.31935 5.70358L5.69435 5.70485H5.31935C5.31935 5.70463 5.31935 5.70442 5.31935 5.70421ZM7.99246 3.78223C6.93041 3.78223 6.06935 4.64301 6.06935 5.70485V5.70611H6.06935C6.06577 6.76364 6.92009 7.624 7.97687 7.62794H7.99246C9.0543 7.62794 9.91508 6.76689 9.91508 5.70485C9.91508 4.6429 9.0544 3.78223 7.99246 3.78223Z",
				fill: "currentColor",
				fillOpacity: .24
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2539_121414",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgNoUserLine;
